import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  close: {
    defaultMessage: 'Close',
    description: 'Button that dismisses a dialog or message',
  },
});

export default messages;
